<template>
   <div class="app-container">
    <header-bar></header-bar>
    <div class="search-page">
        <!-- Show search UI if we haven't searched yet -->
        <div v-if="!hasSearched" class="search-container">
          <!-- <input
            v-model="searchInput"
            type="text"
            class="styled-input"
            placeholder="Enter a question..."
          /> -->
          <textarea
            v-model="searchInput"
            @input="autoResize"
            class="styled-input"
            placeholder="Enter a question..."
          ></textarea>
          <div class="toggle-group">
            <div class="toggle">
              <label class="input-label">Timeframe:</label>
              <select v-model="selectedTimeframe" class="styled-input">
                <option value="3m">3 Months</option>
                <!-- //<option value="6m">6 Months</option>
                //<option value="12m">12 Months</option> -->
              </select>
            </div>
            <div class="toggle">
              <label class="input-label">Task Type:</label>
              <select v-model="selectedTaskType" class="styled-input">
                <!-- <option value="summary">Summarize a Topic</option> -->
                <option value="question">Answer a Specific Question</option>
              </select>
            </div>
            <!-- <div class="toggle">
              <label class="input-label">Meeting Type:</label>
              <select v-model="selectedMeetingType" class="styled-input">
                <option value="selectboard">Selectboard Meetings</option>
                <option value="schoolBoard">School Board Meetings</option>
              </select>
            </div> -->
            <div class="toggle">
              <label class="input-label">Town:</label>
              <select v-model="selectedTownName" class="styled-input">
                <option value="Goshen">Goshen</option>
                <option value="Brandon">Brandon</option>
              </select>
            </div>
          </div>
          <button
            @click="handleSearch"
            class="search-button"
            :disabled="loading || !searchInput.trim()"
          >
            Search
          </button>
        </div>

        <!-- Show answer once search is triggered -->
        <div v-else class="answer-container">
          <div v-if="loading" class="loading">Please hold. We are processing hours of meetings.</div>
          <div v-else class="answer">
            <button @click="resetSearch" class="new-search-button">
              <img src="@/assets/left arrow icon.svg" alt="Left Arrow" class="arrow-icon" />
              Start A New Search
            </button>
            <p class="search-criteria">
              <strong>Your Search Criteria:</strong> <span>{{ searchInput }}</span>
            </p>
            <p class="answer-text">
              <strong>Answer:</strong> <span v-html="answer"></span>
            </p>
          </div>
        </div>
    </div>
    <footer-bar></footer-bar>
   </div>
  </template>
  
  <script>
  import HeaderBar from './RevisedHeader.vue';
  import FooterBar from './FooterBar.vue';

  export default {
    name: "SearchComponent",
    components: {
        HeaderBar,
        FooterBar
    },
    data() {
      return {
        searchInput: "",
        selectedTimeframe: "3m",
        selectedTaskType: "question",
        selectedMeetingType: "selectboard",
        selectedTownName: "Goshen",
        loading: false,
        hasSearched: false,
        answer: "",
      };
    },
    methods: {
      autoResize(e) {
        e.target.style.height = '2rem'; // reset the height
        e.target.style.height = `${e.target.scrollHeight}px`; // set new height
      },
      
      async handleSearch() {
        // Swap the search UI for the answer view, babe.
        this.hasSearched = true;
        this.loading = true;
        this.answer = "";
        try {
          // This fetch call should point to your backend endpoint
          // which wraps your Node.js code (GCS, Gemini, etc.).
          const res = await fetch("/flashapi", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              timeframe: this.selectedTimeframe,
              taskType: this.selectedTaskType,
              userInput: this.searchInput,
              townName: this.selectedTownName,
            }),
          });
          const data = await res.json();
          this.answer = data.answer;
        } catch (err) {
          console.error("Error during search, babe:", err);
          this.answer = "An error occurred. Please try again.";
        } finally {
          this.loading = false;
        }
      },
      resetSearch() {
        // Reset to initial state for a new search.
        this.hasSearched = false;
        this.searchInput = "";
        this.answer = "";
      },
    },
  };
  </script>
  
  <style scoped>
  .app-container {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-color: #fffff8;
  }

  .search-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: #fffff8;
  }
  
  .search-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 50%;
    padding-bottom: 20px;
    background-color: #fffff8;
  }
  
  .toggle-group {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  
  .toggle {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  .input-label {
    font-size: 1rem;
    color: #545051;
    margin-bottom: 4px;
  }
  
  .styled-input {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    resize: none;
    height: 2rem; /* adjust as needed */
    font-size: 1rem;
    border: none;
    border-bottom: 1px solid #545051;
    background: transparent;
    padding: 4px 0;
    outline: none;
  }
  
  .styled-input:focus {
    border-bottom: 2px solid #545051;
  }
  
  .search-button {
    background-color: #545051;
    color: white;
    border: none;
    padding: 8px 24px;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .search-button:hover {
    background-color: #636063;
  }
  
  .search-button:disabled {
    background-color: #a8a8a8;
    cursor: not-allowed;
  }
  
  .answer-container {
    text-align: left;
    width: 50%;
    padding: 32px 0;
    background-color: #fffff8;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .loading {
    font-size: 1.2rem;
    color: #545051;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 84px;
  }

  .answer {
    font-size: 1rem;
    color: #545051;
    white-space: pre-wrap;
    width: 100%;
  }
  .search-criteria,
  .answer-text {
    margin-bottom: 16px;
  }
  .new-search-button {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #545051;
  text-decoration: underline dotted;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 16px;
  text-underline-offset: 4px;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

@media (max-width: 768px) {
  .search-container,
  .answer-container {
    width: 90%;
    padding: 16px;
  }
  
  .toggle-group {
    flex-direction: column;
    gap: 20px;
  }

  .styled-input {
    font-size: 0.9rem;
  }
  
  .search-button {
    font-size: 0.9rem;
    padding: 6px 16px;
  }
}

@media (max-width: 480px) {
  .input-label {
    font-size: 0.8rem;
  }

  .styled-input {
    font-size: 0.8rem;
  }
}
  </style>
  